import { render, staticRenderFns } from "./historyFiltersSearch.vue?vue&type=template&id=470a60f0&scoped=true&"
import script from "./historyFiltersSearch.vue?vue&type=script&lang=js&"
export * from "./historyFiltersSearch.vue?vue&type=script&lang=js&"
import style0 from "./historyFiltersSearch.vue?vue&type=style&index=0&id=470a60f0&lang=scss&scoped=true&"
import style1 from "./historyFiltersSearch.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470a60f0",
  null
  
)

export default component.exports